/**
 * @desc 列表
 */
const URL = "/rantion-report";
import http, { updateResponse } from "@/http";
export function request(params: API.report.importTaskRecord.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/importTaskRecord/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
